import script from "./ApiMockModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiMockModal.vue?vue&type=script&setup=true&lang=js"

import "./ApiMockModal.vue?vue&type=style&index=0&id=314e6ec2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314e6ec2"]])

export default __exports__